import Trie from './res/trie';
import cantoneseData from './res/new.json';

export const trie = new Trie();

export const createCantoneseTrie = (dictionary: object): Trie => {
    const dictionaryTrie = new Trie();
    Object.keys(dictionary).forEach((word) => dictionaryTrie.insert(word));
    return dictionaryTrie;
};

export const refreshTrie = (): void => {
    Object.entries(cantoneseData).forEach(([key]) => trie.insert(key));
};

refreshTrie();
